import React from "react";
import { Link } from "react-router-dom";

export default function FooterAdmin() {
  return (
    <>
      <footer className="block py-4">
        <div className="container mx-auto px-4">
          <hr className="mb-4 border-b-1 border-blueGray-200" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-8/12">
              <div className="text-sm text-blueGray-500 w-fit font-semibold py-1 text-center md:text-left">
                Copyright © 2025 {" | "}
                <a
                href="https://https://www.slu-laboratory-resources.engineering/"
                className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
                target="_blank"
                rel="noreferrer"
                >
                   
                </a>
                CYRILL JAMES B. FIDER {" "}
                <br/>
                Disclaimer: This project is purely for educational and presentation purposes only
                <a
                href="https://https://www.slu-laboratory-resources.engineering/"
                className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
                target="_blank"
                rel="noopener noreferrer"
                >
                  
                </a>
              </div>
            </div>
            <div className="w-full md:w-4/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                <li>
                  <a
                    href="https://https://www.slu-laboratory-resources.engineering/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                  >
                    
                  </a>
                </li>
                <li>
                  <Link
                  onClick={(e) => e.preventDefault()}
                  to=""
                    className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                  >
                    
                  </Link>
                </li>
                <li>
                  <Link
                  onClick={(e) => e.preventDefault()}
                  to=""
                    className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                  >
                    
                  </Link>
                </li>
                <li>
                  <Link
                  onClick={(e) => e.preventDefault()}
                  to=""
                  
                    className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                  >
                    
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
